/**
 * YumoPot — floating brewing-pot icon with rising steam.
 * Uses YUMO saffron (currentColor). Pure SVG + CSS keyframes; no dependencies.
 */
export default function YumoPotIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <style>{`
        @keyframes yumo-steam-a { 0% { opacity: 0; transform: translateY(2px) scale(0.9); } 40% { opacity: .85; } 100% { opacity: 0; transform: translateY(-6px) scale(1.15); } }
        @keyframes yumo-steam-b { 0% { opacity: 0; transform: translateY(3px) scale(0.85); } 50% { opacity: .7; } 100% { opacity: 0; transform: translateY(-7px) scale(1.2); } }
        .steam-a { animation: yumo-steam-a 2.6s ease-in-out infinite; transform-origin: center; }
        .steam-b { animation: yumo-steam-b 2.8s ease-in-out infinite 0.6s; transform-origin: center; }
      `}</style>
      {/* Steam curls */}
      <path className="steam-a" d="M12 5 C11 6.5, 13 7.5, 12 9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.6" />
      <path className="steam-b" d="M16 4 C15 5.8, 17 6.8, 16 8.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.6" />
      <path className="steam-a" d="M20 5 C19 6.5, 21 7.5, 20 9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.6" />
      {/* Pot body */}
      <path d="M6 14 h20 v2 a4 4 0 0 1 -4 4 h-12 a4 4 0 0 1 -4 -4 z" fill="currentColor" opacity="0.15" />
      <path d="M6 14 h20 v2 a4 4 0 0 1 -4 4 h-12 a4 4 0 0 1 -4 -4 z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      {/* Lid */}
      <rect x="4.5" y="11.5" width="23" height="3" rx="1.2" fill="currentColor" opacity="0.9" />
      <circle cx="16" cy="10.5" r="1" fill="currentColor" />
      {/* Handles */}
      <path d="M4 16 c-1 0 -1 3 1 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <path d="M28 16 c1 0 1 3 -1 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
    </svg>
  );
}
